import { SVGProps } from 'react';

export type StatusCellDisplayMode =
  | 'status'
  | 'status_results'
  | 'status_results_comments'
  | 'status_results2_comments';

export function StatusCellDisplayIcon({
  mode = 'status_results2_comments',
  className = '',
  'aria-hidden': ariaHidden = true,
  ...props
}: SVGProps<SVGSVGElement> & {
  mode?: StatusCellDisplayMode;
}) {
  // Determine colors based on mode
  const circleColor = mode === 'status' ? '#9ca3af' : 'currentColor'; // gray-400 for status mode
  const circleFill = mode === 'status_results2_comments' ? 'currentColor' : 'none';
  const triangleColor = mode === 'status' ? '#9ca3af' : 'currentColor'; // gray-400 for status mode
  const showTriangle = mode === 'status_results_comments' || mode === 'status_results2_comments';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={1.5}
      className={className}
      aria-hidden={ariaHidden}
      {...props}
    >
      {/* Four circles in 2x2 grid layout similar to ResultCirclesSVG */}
      <circle cx="7" cy="7" r="3" fill={circleFill} stroke={circleColor} strokeWidth={1.5} />
      <circle cx="17" cy="7" r="3" fill={circleFill} stroke={circleColor} strokeWidth={1.5} />
      <circle cx="7" cy="17" r="3" fill={circleFill} stroke={circleColor} strokeWidth={1.5} />
      <circle cx="17" cy="17" r="3" fill={circleFill} stroke={circleColor} strokeWidth={1.5} />

      {/* Triangle comment indicator in upper right - larger and overlapping */}
      {showTriangle && (
        <path
          d="M10 3 L21 3 L21 14 Z"
          fill={triangleColor}
          stroke={triangleColor}
          strokeWidth={0.3}
        />
      )}
    </svg>
  );
}
